import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft, Calendar, Download, Leaf } from "lucide-react";
import { PageHero } from "../About";
import { QuickFactsCard } from "./CampusLifePageParts";

const activityRows = [
  ["01", "KALKI bio-Culture MoU and preparation demo", "28/07/2025"],
  ["02", "Tree Plantation Activity for Environmental Sustainability", "22/04/2026"],
  ["03", "Environmental Earth Day Pledge Taking Activity", "22/04/2026"],
  ["04", "Save Water and Plastic-Free Campus", "28/04/2026"],
  [
    "05",
    "One Day Talk on \"Engineering the Future through UN Sustainable Development Goals (UNSDGs)\"",
    "11/03/2026",
  ],
  ["06", "One day social outreach program on sustainability awareness", "29/04/2026"],
  ["07", "Environmental and Energy Audit", "11/02/2026"],
  ["08", "Waste Segregation Awareness Program", "29/04/2026"],
  ["09", "Bharat Environment Protection Platinum Sustainable Campus award", "01/06/2026"],
  ["10", "ECO Club Environmental Day", "To be updated"],
  ["11", "Bharat Environment Program (BEP)", "To be updated"],
];

const ecoClubActivityPath = "/Clubs/EcoClub_Activities";

const activities = [
  {
    title: "KALKI Bio-Culture",
    description:
      "An awareness and demonstration activity introducing KALKI bio-culture practices, MoU orientation, and preparation methods for sustainable campus and community applications.",
    report: `${ecoClubActivityPath}/KALKI_Bio_Culture.docx`,
  },
  {
    title: "Tree Plantation Activity for Environmental Sustainability",
    description:
      "A green initiative focused on tree plantation, biodiversity support, and student participation in improving the environmental health of the campus.",
    reports: [
      {
        label: "Report",
        url: `${ecoClubActivityPath}/Tree plantation and Pledge2026.pdf`,
      },
    
    ],
  },
  {
    title: "Environmental Earth Day Pledge Taking Activity",
    description:
      "A pledge-taking activity conducted to encourage students and staff to adopt responsible environmental practices and contribute to Earth Day goals.",
    report:
      `${ecoClubActivityPath}/Environmental_Earth_Day_Pledge_Taking_Activity.docx`,
  },
  {
    title: "Save Water and Plastic-Free Campus",
    description:
      "A campus awareness initiative promoting water conservation, reduced plastic use, and responsible habits among students and staff.",
    report: `${ecoClubActivityPath}/Save_Water_and_Plastic_Free_Campus.docx`,
  },
  {
    title:
      "One Day Talk on \"Engineering the Future through UN Sustainable Development Goals (UNSDGs)\"",
    description:
      "A technical awareness session connecting engineering education with the United Nations Sustainable Development Goals and future-focused sustainability practices.",
    report: `${ecoClubActivityPath}/UNSDG talk ECO CLUB 2026.pdf`,
  },
  {
    title: "One day social outreach program on sustainability awareness",
    description:
      "A community-oriented outreach programme conducted to spread awareness about sustainability, environmental care, and responsible civic action.",
    report:
      `${ecoClubActivityPath}/One-day_social_outreach_program_on_sustainability_awareness.docx`,
  },
  {
    title: "Environmental and Energy Audit",
    description:
      "An institutional audit activity reviewing environmental and energy practices to support resource efficiency and sustainable campus development.",
    report: `${ecoClubActivityPath}/Environmental_and_Energy_Audit.docx`,
  },
  {
    title: "Waste Segregation Awareness Program",
    description:
      "An awareness programme encouraging proper waste segregation, cleaner surroundings, and responsible waste management practices.",
    reports: [
      {
        label: "Report",
        url: `${ecoClubActivityPath}/Waste_Segregation_Awareness_Program.docx`,
      },
   
    ],
  },
  {
    title: "ECO Club Environmental Day",
    description:
      "An Eco Club activity focused on environmental awareness, responsible campus participation, and student engagement in sustainability practices.",
    report: `${ecoClubActivityPath}/ECO CLUB Envronmetal Day 2026.pdf`,
  },
  {
    title: "Bharat Environment Program (BEP)",
    description:
      "A Bharat Environment Program activity supporting environmental responsibility, green campus practices, and awareness among students and staff.",
    report: `${ecoClubActivityPath}/BEP Notice 2026.pdf`,
  },
];

const quickFacts = [
  ["Category", "Student Clubs"],
  ["Club", "Eco Club"],
  ["Focus", "Sustainability"],
  ["Activity Year", "2025-26"],
  ["Activities Conducted", "11"],
  ["Reports Available", "10"],
  ["Audit", "Environmental and Energy Audit"],
  ["Recognition", "Platinum Sustainable Campus award"],
];

const EcoClub = () => (
  <main>
    <PageHero
      title="Eco Club"
      sub="Green initiatives, sustainability awareness, and student participation in environmental action"
      image="/Campus/ecoclub.png"
    />

    <section className="max-w-7xl mx-auto px-6 lg:px-10 py-14">
      <Link
        to="/clubs"
        className="inline-flex items-center gap-2 text-sm font-semibold text-brand hover:underline mb-8"
      >
        <ArrowLeft size={16} />
        Back to Clubs
      </Link>

      <div className="grid lg:grid-cols-3 gap-8 items-start">
        <section className="lg:col-span-2 bg-white border border-brand/15 p-7 md:p-9">
          <div className="flex items-center gap-3 mb-4">
            <div className="w-11 h-11 border border-brand/20 flex items-center justify-center text-brand">
              <Leaf size={22} />
            </div>
            <p className="text-xs uppercase tracking-[0.24em] text-brand font-semibold">
              Sustainability Club
            </p>
          </div>

          <h2
            className="text-3xl md:text-5xl text-brand font-semibold leading-tight"
            style={{ fontFamily: "'Cormorant Garamond', serif" }}
          >
            ECO CLUB 2025-26 Activity conducted
          </h2>

          <p className="mt-5 text-[16px] text-[#2a2a2a]/85 leading-relaxed">
            Eco Club promotes green practices, environmental awareness,
            sustainability outreach, and responsible campus participation
            through student-led initiatives and institutional activities.
          </p>
        </section>

        <aside className="space-y-5 lg:sticky lg:top-32">
          <div className="bg-white border border-brand/15 p-5">
            <QuickFactsCard facts={quickFacts} />
          </div>

        
        </aside>
      </div>

      <section className="mt-12">
        <div className="bg-white border border-brand/15 overflow-hidden">
          <div className="text-center px-4 py-5">
            <h3 className="text-2xl md:text-3xl text-brand font-bold underline">
              ECO CLUB
            </h3>
            <p className="text-2xl md:text-3xl text-brand font-bold underline mt-1">
              2025-26
            </p>
            <p className="text-2xl md:text-3xl text-brand font-bold underline mt-1">
              Activity conducted
            </p>
          </div>
          <table className="w-full table-fixed border-collapse text-sm md:text-base">
            <thead>
              <tr className="bg-surface-alt/70">
                <th className="w-16 border border-brand/30 px-3 py-2 text-left">
                  Sl. No
                </th>
                <th className="border border-brand/30 px-3 py-2 text-left">
                  Green initiation
                </th>
                <th className="w-32 border border-brand/30 px-3 py-2 text-left">
                  Date
                </th>
              </tr>
            </thead>
            <tbody>
              {activityRows.map(([serial, initiative, date]) => (
                <tr key={serial}>
                  <td className="border border-brand/30 px-3 py-2 align-top font-semibold">
                    {serial}
                  </td>
                  <td className="border border-brand/30 px-3 py-2 align-top">
                    {initiative}
                  </td>
                  <td className="border border-brand/30 px-3 py-2 align-top">
                    {date}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </section>

      <section className="mt-12">
        <p className="text-xs uppercase tracking-[0.24em] text-brand font-semibold mb-4">
          Activities
        </p>
        <div className="grid md:grid-cols-2 gap-5">
          {activities.map((activity) => (
            <article key={activity.title} className="bg-white border border-brand/15 p-5">
              <div className="flex items-start gap-3">
                <div className="w-10 h-10 border border-brand/20 flex items-center justify-center text-brand flex-shrink-0">
                  <Calendar size={18} />
                </div>
                <div>
                  <h3 className="text-xl text-brand font-semibold leading-snug">
                    {activity.title}
                  </h3>
                  <p className="text-sm text-[#2a2a2a]/85 leading-relaxed mt-2">
                    {activity.description}
                  </p>
                  <div className="mt-4 flex flex-wrap gap-2">
                    {(activity.reports || [
                      { label: "Report", url: activity.report },
                    ]).map((report) => (
                      <a
                        key={report.url}
                        href={report.url}
                        download
                        className="inline-flex items-center gap-2 bg-brand text-white px-4 py-2 text-xs font-semibold tracking-wider uppercase hover:bg-brand-dark transition"
                      >
                        <Download size={14} />
                        {report.label}
                      </a>
                    ))}
                  </div>
                </div>
              </div>
            </article>
          ))}
        </div>
      </section>
    </section>
  </main>
);

export default EcoClub;
